<template>
  <AdblockTopbar />
  <div class="px-4 sm:px-6 lg:px-16 max-w-screen-xl lg:mx-auto">
    <HeaderApp />

    <div class="text__view flex flex-col justify-center text-center mb-5">
      <h1 class="font-semibold text-2xl my-5">
        {{ case_study_title_subtitle.title }}
      </h1>
      <p class="leading-6 max-w-5xl mx-auto">
        {{ case_study_title_subtitle.subtitle }}
      </p>
    </div>
    <template v-if="cases && cases.length">
      <div v-if="['free'].includes(roleUser)">
        <UpgradePlans :text="' 65+ marketing case studies'" />
        <div class="library__list py-4 lg:py-10 items-start">
          <Case
            v-for="casestudy in free_cases"
            :key="casestudy.id"
            :data="casestudy"
            class="library__item"
            :isCollection="false"
            :lock="false"
          />
        </div>
        <div class="library__list py-4 lg:py-10 items-start">
          <Case
            v-for="casestudy in cases"
            :key="casestudy.id"
            :data="casestudy"
            class="library__item"
            :isCollection="false"
            :lock="true"
          />
        </div>
      </div>
      <div v-else class="library__list py-4 lg:py-10 items-start">
        <Case
          v-for="casestudy in cases"
          :key="casestudy.id"
          :data="casestudy"
          class="library__item"
          :isCollection="false"
          :lock="false"
        />
      </div>
    </template>
    <div
      class="grid mt-24 p-8 text-center justify-center items-center content-center my-auto"
      v-else
    >
      <div>
        <h2 class="text-4xl font-semibold mb-4">
          Looking for Cases of study 👀
        </h2>
        <p class="mb-10 text-lg">
          We recommend you check the completed library and select the awesome
          ads for you
        </p>
        <router-link to="/case-studies" class="flex justify-center">
          <Button class="px-12 bg-indigo-600 hover:bg-indigo-500 text-white"
            >Clean filters</Button
          >
        </router-link>
      </div>
    </div>
    <Pagination
      :totalElements="totalCases"
      :pageView="pageCases"
      nameView="Cases"
    />
  </div>
</template>

<script>
import { computed, onBeforeMount } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import HeaderApp from "@/components/Header";
import AdblockTopbar from "@/components/AdblockTopbar";
import Case from "@/components/Cases/index";
import Button from "@/components/UI/Button";
import Pagination from "@/components/Pagination";
import UpgradePlans from "@/components/UpgradePlans";

export default {
  components: {
    HeaderApp,
    AdblockTopbar,
    Button,
    Case,
    Pagination,
    UpgradePlans,
  },
  setup() {
    const router = useRouter();

    onBeforeMount(async () => {
      const status = computed(() => store.state.status);
      if (!status.value) {
            console.log("1")

        router.push("/pricing");
      } else {
        await store.dispatch("GET_CASES_STUDY");
      }
    });
    const store = useStore();
    const cases = computed(() => store.state.cases);
    const free_cases = computed(() => store.state.freeCases);
    const totalCases = computed(() => store.state.totalCases);
    const pageCases = computed(() => store.state.pageCases);
    const roleUser = computed(() => store.state.role);
    const case_study_title_subtitle = computed(
      () => store.state.caseStudiesTitleSubtitle
    );
    return {
      roleUser,
      case_study_title_subtitle,
      cases,
      free_cases,
      totalCases,
      pageCases,
    };
  },
};
</script>

<style scoped>
.tips__wrapper {
  @apply grid;
  grid-template-columns: repeat(auto-fit, minmax(19rem, 22rem));
}
.button__tips {
  border-radius: 20px;
}
.library__list {
  @apply grid gap-y-12 gap-x-16;
  justify-content: space-between;
  grid-template-columns: repeat(auto-fit, minmax(10rem, 15rem));
}
.library__item {
  max-width: 24rem;
  min-width: 18rem;
  width: 100%;
}
.button__tips-text::before {
  display: block;
  content: " ";
  height: 3px;
  width: 20%;
  position: absolute;
  left: 40%;
  top: -15px;
  margin-bottom: 10px;
  margin-right: 10px;
  @apply bg-indigo-600;
}
</style>
